import noahPic from "@/public/images/artists/noah.jpg";
import { Artist } from "@/types/types";

export const noah = {
  id: "199",
  name: "Noah",
  image: noahPic,
  description: `Noah's voice is sweet and soulful, blending natural warmth and clarity with a mellow tone that suits a wide range of styles and genres.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fnoah-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Kids",
        "Unprocessed",
        "RnB",
        "Soul",
        "Classical",
        "Theatrical",
        "Airy",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 57,
        high: 74,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
